module.exports = __webpack_public_path__ + "img/image.79929c2e.png";